import { tv as t } from "tailwind-variants";
const a = t({
  base: "relative w-full text-slate-900",
  slots: {
    content: "flex gap-3 p-4",
    action1: "px-4 py-1 h-8 !text-s3 font-semibold rounded-full",
    action2: "px-4 py-1 h-8 !text-s3 font-semibold rounded-full"
  },
  variants: {
    mode: {
      bright: "",
      vibrant: ""
    },
    variant: {
      success: "",
      error: "",
      warning: "",
      info: "",
      notification: ""
    },
    orientation: {
      vertical: {},
      horizontal: {}
    },
    isRounded: {
      true: {
        base: "rounded-lg"
      },
      false: {
        base: "rounded-none"
      }
    }
  },
  defaultVariants: {
    variant: "info",
    orientation: "horizontal"
  },
  compoundVariants: [
    // success
    {
      mode: "bright",
      variant: "success",
      className: {
        base: "bg-warmGreen-50",
        action1: "text-slate-white bg-warmGreen-500 text-white",
        action2: ""
      }
    },
    {
      mode: "vibrant",
      variant: "success",
      className: {
        base: "bg-warmGreen-500 text-white",
        action1: "text-white bg-warmGreen-300",
        action2: "text-white"
      }
    },
    // error
    {
      mode: "bright",
      variant: "error",
      className: {
        base: "bg-red-50",
        action1: "bg-red-500 text-white",
        action2: ""
      }
    },
    {
      mode: "vibrant",
      variant: "error",
      className: {
        base: "bg-red-500 text-white",
        action1: "text-white bg-red-300",
        action2: "text-white"
      }
    },
    // warning
    {
      mode: "bright",
      variant: "warning",
      className: {
        base: "bg-orange-50",
        action1: "bg-orange-500 text-white",
        action2: ""
      }
    },
    {
      mode: "vibrant",
      variant: "warning",
      className: {
        base: "bg-orange-500",
        action1: "text-white bg-orange-300",
        action2: "text-white"
      }
    },
    // info
    {
      mode: "bright",
      variant: "info",
      className: {
        base: "bg-slate-50",
        action1: "bg-slate-500 text-white",
        action2: ""
      }
    },
    {
      mode: "vibrant",
      variant: "info",
      className: {
        base: "bg-slate-500 text-white",
        action1: "text-white bg-slate-300",
        action2: "text-white"
      }
    },
    // notification
    {
      mode: "bright",
      variant: "notification",
      className: {
        base: "bg-gradient-light-blue",
        action1: "bg-blue text-white",
        action2: "text-blue"
      }
    },
    {
      mode: "vibrant",
      variant: "notification",
      className: {
        base: "bg-gradient-main",
        action1: "text-white bg-blue",
        action2: "text-white"
      }
    }
  ]
});
export {
  a as alertVariants
};
